import { css } from 'styled-components';

export const scrollbarColoredHoverMixin = (
  color = 'rgba(17, 17, 17, 0.1)',
  hoverColor = 'rgba(17, 17, 17, 0.15)'
) => css`
  scrollbar-width: auto;
  scrollbar-gutter: stable;

  // Support for previous Chrome version <121
  @supports not (scrollbar-width: thin) {
    scrollbar-width: thin;
  }

  @supports (-moz-appearance: none) {
    scrollbar-width: thin;
    scrollbar-color: ${color} transparent;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: inherit;
    border-radius: inherit;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background-color: ${color};

    &:hover {
      background-color: ${hoverColor};
    }
  }
`;
